import Vue from "vue";
import VueAnalytics from "vue-ua";
import { version } from "../package.json";
import App from "./components/App.vue";
import { setEnv } from "./utils/env";

// Vue.mixin(metaMixin)


import { RegisterComponents } from "./components";
import { RegisterFilters } from "./utils/filters";
import { RegisterPrototypes } from "./utils/prototypes";
import { RegisterMixins } from "./utils/mixins";

import { initializeLocales } from "./plugins/i18n";

import { getCountryConfigs } from "./config";
import { setupRoutes } from "./router";
import store from "./store";

function extractUtmSourceAndCommit() {
	// console.log('Current URL search part:', window.location.search);

	const queryParams = new URLSearchParams(window.location.search);
	let utmmedium = queryParams.get("utm_medium");
	let utmSource = queryParams.get("utm_source");
	let utmCampaign = queryParams.get("utm_campaign");

	let utm = {
		medium: utmmedium,
		source: utmSource,
		campaign: utmCampaign,
	};
	store.dispatch("updateUtmSource", utm);

}

(async () => {
	const appConfig = { router: null, i18n: null, metaData: null };

	let countryConfigs = getCountryConfigs();
	await setEnv(countryConfigs);
	const i18n = await initializeLocales();

	let router = await setupRoutes();

	await RegisterComponents();
	await RegisterFilters();
	await RegisterMixins();
	await RegisterPrototypes();

	// Extract utm_source before initializing the app
	await extractUtmSourceAndCommit();

	let meta = {};

	if (Object.keys(countryConfigs).length > 0) {
		meta = {
			title: countryConfigs.websiteTitle,
			meta: [
				{
					vmid: "description",
					name: "description",
					content: countryConfigs.websiteDescription,
				},
				{
					vmid: "keywords",
					name: "keywords",
					content: countryConfigs.websiteKeywords,
				},
				{
					vmid: "apple-itunes-app",
					name: "apple-itunes-app",
					content: `app-id=${countryConfigs.iosAppId}, app-argument=${countryConfigs.mobileUrl}`,
				},
				{
					vmid: "og:title",
					property: "og:title",
					content: countryConfigs.websiteTitle,
				},
				{
					vmid: "og:description",
					property: "og:description",
					content: countryConfigs.websiteDescription,
				},
				{
					vmid: "og:url",
					property: "og:url",
					content: countryConfigs.websiteUrl,
				},
				{
					vmid: "og:image",
					property: "og:image",
					content: countryConfigs.websiteOpenGraphImage,
				},
				{
					vmid: "twitter:card",
					name: "twitter:card",
					content: "summary_large_image",
				},
				{
					vmid: "twitter:site",
					name: "twitter:site",
					content: countryConfigs.socialUrls.twitter,
				},
				{
					vmid: "twitter:title",
					name: "twitter:title",
					content: countryConfigs.websiteTitle,
				},
				{
					vmid: "twitter:description",
					name: "twitter:description",
					content: countryConfigs.websiteDescription,
				},
				{
					vmid: "twitter:creator",
					name: "twitter:creator",
					content: countryConfigs.socialUserNames.twitterUsername,
				},
				{
					vmid: "twitter:image",
					name: "twitter:image",
					content: countryConfigs.websiteOpenGraphImage,
				},
				{
					vmid: "name",
					itemprop: "name",
					content: countryConfigs.websiteTitle,
				},
				{
					vmid: "description",
					itemprop: "description",
					content: countryConfigs.websiteDescription,
				},
				{
					vmid: "image",
					itemprop: "image",
					content: countryConfigs.websiteOpenGraphImage,
				},
			],
			link: [
				{
					rel: "canonical",
					href: countryConfigs.websiteUrl + (window.location.pathname !== '/' ? window.location.pathname : '')
				}
			]
		};
		if (process.env.NODE_ENV == "production") {
			Vue.use(VueAnalytics, {
				appName: "MOBILE_WEB",
				appVersion: version,
				trackingId: countryConfigs.gaID,
				debug: true,
				vueRouter: router,
			});

			meta = Object.assign({}, meta, {
				script: [
					{
						innerHTML: `
								(function (w, d, s, l, i) {
									w[l] = w[l] || [];
									w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
									var f = d.getElementsByTagName(s)[0],
										j = d.createElement(s),
										dl = l != "dataLayer" ? "&l=" + l : "";
									j.async = true;
									j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
									f.parentNode.insertBefore(j, f);
								})(
									window,
									document,
									"script",
									"dataLayer",
									"${countryConfigs.gtmID}"
								);
						`,
					},
				],
				noscript: [
					{
						innerHTML: `
								<iframe
									src="https://www.googletagmanager.com/ns.html?id=${countryConfigs.gtmID}"
									height="0"
									width="0"
									style="display: none; visibility: hidden"
								></iframe
							>
							`,
					},
				],
			});
		}
	}

	appConfig.metaData = meta;
	appConfig.router = router;
	appConfig.i18n = i18n;
	return appConfig;
})().then(async (appConfig) => {
	const app = new Vue({
		metaInfo() {
			return appConfig.metaData;
		},
		router: appConfig.router,
		i18n: appConfig.i18n,
		el: "#app",
		render: (h) => h(App),
	});
	window.betika = app;
});
